import { Component, Suspense, useRef } from "react";
import { useInView } from "framer-motion";

class Boundary extends Component {
  state = { failed: false };
  static getDerivedStateFromError() {
    return { failed: true };
  }
  render() {
    return this.state.failed ? this.props.fallback : this.props.children;
  }
}

export const LazyCanvas = ({ Scene, fallback = null, className = "", testId, ...props }) => {
  const ref = useRef(null);
  const inView = useInView(ref, { amount: 0.05 });
  return (
    <div ref={ref} className={className} data-testid={testId}>
      <Boundary fallback={fallback}>
        <Suspense fallback={fallback}>
          <Scene active={inView} {...props} />
        </Suspense>
      </Boundary>
    </div>
  );
};
